$('.js-table-of-contents-mobile-header').click(function() 
{
    $(this).toggleClass('active');
    $(this).next('.js-table-of-contents-mobile-body').toggleClass('active');
});